<template>
	<div class="bkf7 gameall_list" v-if="login && isAdmin">
		<el-container>
			<div class="inter2">
				<div class="filter-keywords-search" v-if="!isMobile">
					<div class="filter-search-label">关键词</div>
					<div class="filter-search-info">
						<div class="filter-search-input el-input el-input--suffix">
							<input type="text" autocomplete="off" v-model="keyword" placeholder="请输入客服姓名"
								class="el-input__inner"><span class="el-input__suffix">
								<span class="el-input__suffix-inner" @click="Search">
									<div class="search">搜索</div>
								</span></span>
						</div>
					</div>
				</div>
				<div class="mobile-filter-search" v-if="isMobile">
					<div class="mobile-search-box">
						<input type="text" v-model="keyword" placeholder="请输入客服姓名" class="mobile-search-input" />
						<button class="mobile-search-btn" @click="Search">搜索</button>
					</div>
				</div>
				
				<div class="action-bar">
					<el-button type="primary" style="background: #1f9535; border-color: #1f9535; color: #fff; border-radius: 5px; padding: 10px 20px;" @click="openDialog()">添加客服</el-button>
					<el-button type="warning" style="background: #e6a23c; border-color: #e6a23c; color: #fff; border-radius: 5px; padding: 10px 20px;" @click="openChazhiDialog()">差值配置</el-button>
					<el-button type="info" style="background: #909399; border-color: #909399; color: #fff; border-radius: 5px; padding: 10px 20px;" @click="openBackupModeDialog()">备份模式配置</el-button>
				</div>

				<div v-if="isMobile">
					<div class="mobile-action-bar" style="display: flex; gap: 10px; padding: 10px;">
						<el-button type="primary" style="flex: 1; background: #1f9535; border-color: #1f9535; color: #fff;" @click="openDialog()">添加客服</el-button>
						<el-button type="warning" style="flex: 1; background: #e6a23c; border-color: #e6a23c; color: #fff;" @click="openChazhiDialog()">差值配置</el-button>
						<el-button type="info" style="flex: 1; background: #909399; border-color: #909399; color: #fff;" @click="openBackupModeDialog()">备份模式</el-button>
					</div>
					<div class="mobile_kefu_list">
						<div class="kefu_item" v-for="(item, index) in list" :key="index">
							<div class="kefu_info">
								<div class="kefu_row">
									<span class="label">客服编号：</span>
									<span class="value">{{ item.kefu_code }}</span>
								</div>
								<div class="kefu_row">
									<span class="label">客服姓名：</span>
									<span class="value">{{ item.name }}</span>
								</div>
								<div class="kefu_row">
									<span class="label">微信号：</span>
									<span class="value">{{ item.wechat }}</span>
								</div>
								<div class="kefu_row" v-if="item.qrcode">
									<span class="label">二维码：</span>
									<img :src="item.qrcode" class="qrcode_img" />
								</div>
								<div class="kefu_row">
									<span class="label">创建时间：</span>
									<span class="value">{{ formatTime(item.createtime) }}</span>
								</div>
							</div>
							<div class="kefu_actions">
								<el-button size="mini" style="background: #1f9535; border-color: #1f9535; color: #fff; border-radius: 3px;" @click="openDialog(item)">修改</el-button>
								<el-button size="mini" style="background: #ff4d4f; border-color: #ff4d4f; color: #fff; border-radius: 3px;" @click="deleteKefu(item.id)">删除</el-button>
							</div>
						</div>
						<div v-if="list.length === 0" class="empty_tip">暂无客服数据</div>
					</div>
				</div>
				<el-table v-else :data="list" border style="width: 100%">
					<el-table-column prop="kefu_code" label="客服编号" width="100">
					</el-table-column>
					<el-table-column prop="name" label="客服姓名" min-width="120">
					</el-table-column>
					<el-table-column prop="wechat" label="微信号" min-width="150">
					</el-table-column>
					<el-table-column prop="admin_nickname" label="绑定管理员" min-width="120">
						<template slot-scope="scope">
							<span>{{ scope.row.admin_nickname || '-' }}</span>
						</template>
					</el-table-column>
					<el-table-column label="二维码" width="100">
						<template slot-scope="scope">
							<img v-if="scope.row.qrcode" :src="fixImageUrl(scope.row.qrcode)" style="width: 50px; height: 50px; object-fit: contain;" />
							<span v-else>-</span>
						</template>
					</el-table-column>
					<el-table-column prop="createtime" label="创建时间" min-width="180">
						<template slot-scope="scope">
							{{ formatTime(scope.row.createtime) }}
						</template>
					</el-table-column>
					<el-table-column fixed="right" label="操作" width="150">
						<template slot-scope="scope">
							<el-button type="text" size="small" @click="openDialog(scope.row)">修改</el-button>
							<el-button type="text" size="small" style="color: #F56C6C;" @click="deleteKefu(scope.row.id)">删除</el-button>
						</template>
					</el-table-column>
				</el-table>
				
				<el-pagination
					@current-change="handleCurrentChange"
					:current-page="page"
					:page-size="limit"
					layout="total, prev, pager, next"
					:total="total">
				</el-pagination>
			</div>
		</el-container>
		
		<el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="600px" @close="dialogClose">
			<el-form :model="form" :rules="rules" ref="form" label-width="120px">
				<el-form-item label="客服姓名" prop="name">
					<el-input v-model="form.name" placeholder="请输入客服姓名"></el-input>
				</el-form-item>
				<el-form-item label="客服微信号" prop="wechat">
					<el-input v-model="form.wechat" placeholder="请输入客服微信号"></el-input>
				</el-form-item>
				<el-form-item label="客服编号" prop="kefu_code">
					<el-select v-model="form.kefu_code" placeholder="请选择客服编号" style="width: 100%;" :disabled="!!form.id">
						<el-option v-for="code in availableCodes" :key="code" :label="code" :value="code"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="绑定管理员" prop="admin_id">
					<el-select v-model="form.admin_id" placeholder="请选择绑定的管理员(非必填)" style="width: 100%;" clearable>
						<el-option v-for="admin in adminList" :key="admin.id" :label="admin.nickname" :value="admin.id"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="客服二维码">
					<el-upload
						class="qrcode-uploader"
						:action="uploadUrl"
						:show-file-list="false"
						:before-upload="beforeUpload"
						:on-success="handleUploadSuccess">
						<img v-if="form.qrcode" :src="form.qrcode" class="qrcode-preview" />
						<i v-else class="el-icon-plus qrcode-icon"></i>
					</el-upload>
					<div class="el-upload__tip" slot="tip">点击上传二维码图片，建议尺寸200x200</div>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible = false">取消</el-button>
				<el-button type="primary" @click="submitForm">确定</el-button>
			</span>
		</el-dialog>
				
		<el-dialog title="差值配置" :visible.sync="chazhiDialogVisible" width="400px" @close="chazhiDialogClose">
			<el-form label-width="100px">
				<el-form-item label="比例差值">
					<el-input-number v-model="chazhiValue" :min="0" :max="100" :step="1"></el-input-number>
					<span style="margin-left: 10px; color: #999;">实际比例 = 管理员填写的比例 - 差值</span>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="chazhiDialogVisible = false">取消</el-button>
				<el-button type="primary" @click="saveChazhi">确定</el-button>
			</span>
		</el-dialog>
		
		<el-dialog title="备份模式配置" :visible.sync="backupModeDialogVisible" width="500px">
			<el-form label-width="120px">
				<el-form-item label="开启备份模式">
					<div class="custom-switch" @click="toggleBackupMode">
						<div class="switch-track" :class="{ 'switch-on': backupModeForm.backup_mode == 1 }">
							<div class="switch-thumb"></div>
						</div>
						<span class="switch-label">{{ backupModeForm.backup_mode == 1 ? '已开启' : '已关闭' }}</span>
					</div>
					<span style="margin-left: 10px; color: #999;">开启后前台将显示24小时前的数据</span>
				</el-form-item>
				<el-form-item label="数据时间范围">
					<el-select v-model="backupModeForm.time_range" placeholder="请选择数据时间范围" style="width: 200px;">
						<el-option label="1小时前" value="1h"></el-option>
						<el-option label="3小时前" value="3h"></el-option>
						<el-option label="6小时前" value="6h"></el-option>
						<el-option label="24小时前" value="24h"></el-option>
						<el-option label="72小时前" value="72h"></el-option>
						<el-option label="7天前" value="7d"></el-option>
					</el-select>
					<span style="margin-left: 10px; color: #999;">只展示该时间范围之前的数据</span>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="backupModeDialogVisible = false">取消</el-button>
				<el-button type="primary" @click="saveBackupMode">确定</el-button>
			</span>
		</el-dialog>
	</div>
	<div v-else>
		<div class="content">
			<p>请先登录管理员账号</p>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				list: [],
				adminList: [],
				page: 1,
				limit: 20,
				total: 0,
				keyword: '',
				dialogVisible: false,
				dialogTitle: '添加客服',
				chazhiDialogVisible: false,
				chazhiValue: 0,
				backupModeDialogVisible: false,
				backupModeForm: {
					backup_mode: 0,
					time_range: '24h'
				},
				form: {
					id: null,
					name: '',
					wechat: '',
					kefu_code: '',
					qrcode: '',
					admin_id: ''
				},
				rules: {
					name: [{ required: true, message: '请输入客服姓名', trigger: 'blur' }],
					wechat: [{ required: true, message: '请输入客服微信号', trigger: 'blur' }],
					kefu_code: [{ required: true, message: '请选择客服编号', trigger: 'change' }]
				},
				uploadUrl: '',
				availableCodes: ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z']
			}
		},
		computed: {
			login() {
				return this.$store.getters.login
			},
			isAdmin() {
				return this.$store.getters.isAdmin
			},
			isMobile() {
				return this.$store.getters.isMobile
			}
		},
		created() {
			this.getList()
			this.getAdminList()
			this.uploadUrl = this.api_url + 'api/common/upload'
		},
		methods: {
			getList() {
				this.rq.requests.post('api/game/hall/getKefuList', {
					page: this.page,
					limit: this.limit,
					keyword: this.keyword
				}).then(res => {
					if (res.code === 1 && res.data) {
						this.list = res.data.data || []
						this.total = res.data.total || 0
					}
				}).catch(err => {
					console.error('获取客服列表失败:', err)
				})
			},
			getAdminList() {
				this.rq.requests.post('api/game/hall/getAdminList', {
					page: 1,
					limit: 100
				}).then(res => {
					if (res.code === 1 && res.data) {
						this.adminList = res.data.data || []
					}
				}).catch(err => {
					console.error('获取管理员列表失败:', err)
				})
			},
			Search() {
				this.page = 1
				this.getList()
			},
			handleCurrentChange(val) {
				this.page = val
				this.getList()
			},
			openDialog(row) {
			if (row) {
				this.dialogTitle = '修改客服'
				this.form = {
					id: row.id,
					name: row.name,
					wechat: row.wechat,
					kefu_code: row.kefu_code,
					qrcode: this.fixImageUrl(row.qrcode),
					admin_id: row.admin_id || ''
				}
			} else {
				this.dialogTitle = '添加客服'
				this.form = {
						id: null,
						name: '',
						wechat: '',
						kefu_code: '',
						qrcode: '',
						admin_id: ''
					}
				}
				this.dialogVisible = true
			},
			dialogClose() {
				this.$refs.form.resetFields()
			},
			beforeUpload(file) {
				const isImage = file.type.startsWith('image/');
				if (!isImage) {
					this.$message.error('只能上传图片格式（jpg/png/jpeg/gif）！');
					return false;
				}
				const isLt5M = file.size / 1024 / 1024 < 5;
				if (!isLt5M) {
					this.$message.error('图片大小不能超过 5MB！');
					return false;
				}
				return true;
			},
			handleUploadSuccess(response, file) {
				if (response.code === 1) {
					let url = response.data.fullurl || response.data.url;
					this.form.qrcode = this.fixImageUrl(url);
					this.$message.success('上传成功');
				} else {
					this.$message.error(response.msg || '上传失败');
				}
			},
			submitForm() {
				this.$refs.form.validate(valid => {
					if (valid) {
						if (this.form.id) {
							this.rq.requests.post('api/game/hall/updateKefu', this.form).then(res => {
								if (res.code === 1) {
									this.$message.success('修改成功')
									this.dialogVisible = false
									this.getList()
								} else {
									this.$message.error(res.msg || '修改失败')
								}
							})
						} else {
							this.rq.requests.post('api/game/hall/addKefu', this.form).then(res => {
								if (res.code === 1) {
									this.$message.success('添加成功')
									this.dialogVisible = false
									this.getList()
								} else {
									this.$message.error(res.msg || '添加失败')
								}
							})
						}
					}
				})
			},
			deleteKefu(id) {
				this.$confirm('确定要删除该客服吗?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.rq.requests.post('api/game/hall/deleteKefu', { id: id }).then(res => {
						if (res.code === 1) {
							this.$message.success('删除成功')
							this.getList()
						} else {
							this.$message.error(res.msg || '删除失败')
						}
					})
				}).catch(() => {})
			},
			formatTime(timestamp) {
				if (!timestamp && timestamp !== 0) return '-'
				try {
					return this.$moment.unix(timestamp).format('YYYY-MM-DD HH:mm:ss')
				} catch(e) {
					return '-'
				}
			},
			openChazhiDialog() {
				this.rq.requests.post('api/game/hall/getChazhiConfig').then(res => {
					if (res.code === 1 && res.data) {
						this.chazhiValue = parseFloat(res.data.chazhi) || 0
					}
				})
				this.chazhiDialogVisible = true
			},
			chazhiDialogClose() {
				this.chazhiValue = 0
			},
			saveChazhi() {
				this.rq.requests.post('api/game/hall/updateChazhiConfig', {
					chazhi: this.chazhiValue
				}).then(res => {
					if (res.code === 1) {
						this.$message.success('保存成功')
						this.chazhiDialogVisible = false
					} else {
						this.$message.error(res.msg || '保存失败')
					}
				})
			},
			openBackupModeDialog() {
				this.rq.requests.post('api/game/hall/getBackupModeConfig').then(res => {
					if (res.code === 1 && res.data) {
						this.backupModeForm.backup_mode = res.data.backup_mode == 1 ? 1 : 0
						this.backupModeForm.time_range = res.data.time_range || '24h'
					}
					this.backupModeDialogVisible = true
				}).catch(() => {
					this.backupModeDialogVisible = true
				})
			},
			toggleBackupMode() {
				this.backupModeForm.backup_mode = this.backupModeForm.backup_mode == 1 ? 0 : 1
			},
			saveBackupMode() {
				this.rq.requests.post('api/game/hall/updateBackupModeConfig', {
					backup_mode: this.backupModeForm.backup_mode,
					time_range: this.backupModeForm.time_range
				}).then(res => {
					if (res.code === 1) {
						this.$message.success('保存成功')
						this.backupModeDialogVisible = false
					} else {
						this.$message.error(res.msg || '保存失败')
					}
				})
			},
			showChazhi(row) {
				this.$prompt('请输入比例差值', '查看/修改比例差值', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					inputValue: row.chazhi || 0,
					inputPattern: /^\d+(\.\d+)?$/,
					inputErrorMessage: '请输入有效的数字'
				}).then(({ value }) => {
					const chazhi = parseFloat(value) || 0
					this.rq.requests.post('api/game/hall/updateKefu', {
						id: row.id,
						name: row.name,
						wechat: row.wechat,
						kefu_code: row.kefu_code,
						qrcode: row.qrcode,
						chazhi: chazhi
					}).then(res => {
						if (res.code === 1) {
							this.$message.success('修改成功')
							this.getList()
						} else {
							this.$message.error(res.msg || '修改失败')
						}
					})
				}).catch(() => {})
			}
		}
	}
</script>

<style scoped>
	.bkf7 {
		background: #f7f7f7;
		min-height: 100vh;
	}
	
	.gameall_list {
		padding: 20px;
	}
	
	.inter2 {
		background: #fff;
		padding: 20px;
		border-radius: 5px;
	}
	
	.filter-keywords-search {
		display: flex;
		align-items: center;
		margin-bottom: 20px;
	}
	
	.filter-search-label {
		width: 80px;
		font-size: 14px;
		color: #333;
	}
	
	.filter-search-info {
		flex: 1;
	}
	
	.filter-search-input {
		width: 300px;
	}
	
	.search {
		width: 50px;
		height: 100%;
		line-height: 32px;
		text-align: center;
		color: #1f9535;
		border-radius: 0 3px 3px 0;
		cursor: pointer;
	}
	
	.action-bar {
		margin-bottom: 20px;
	}
	
	.el-table {
		margin-bottom: 20px;
		width: 100% !important;
	}
	
	.el-pagination {
		text-align: right;
	}
	
	.qrcode-uploader {
		border: 1px dashed #d9d9d9;
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
		width: 120px;
		height: 120px;
		display: flex;
		align-items: center;
		justify-content: center;
	}
	
	.qrcode-uploader:hover {
		border-color: #409EFF;
	}
	
	.qrcode-preview {
		width: 100%;
		height: 100%;
		object-fit: contain;
	}
	
	.qrcode-icon {
		font-size: 28px;
		color: #8c939d;
	}
	
	.el-upload__tip {
		margin-top: 10px;
		color: #909399;
		font-size: 12px;
	}
	
	.mobile-filter-search {
		padding: 10px;
		background: #fff;
		margin-bottom: 10px;
	}
	.mobile-search-box {
		display: flex;
		gap: 10px;
	}
	.mobile-search-input {
		flex: 1;
		height: 36px;
		padding: 0 12px;
		border: 1px solid #ddd;
		border-radius: 4px;
		font-size: 14px;
	}
	.mobile-search-btn {
		padding: 0 20px;
		height: 36px;
		background: #1f9535;
		color: #fff;
		border: none;
		border-radius: 4px;
		cursor: pointer;
		font-size: 14px;
	}
	.mobile_kefu_list {
		padding: 10px;
	}
	.mobile_kefu_list .kefu_item {
		background: #fff;
		border-radius: 8px;
		padding: 15px;
		margin-bottom: 10px;
		box-shadow: 0 2px 8px rgba(0,0,0,0.1);
	}
	.mobile_kefu_list .kefu_info {
		margin-bottom: 12px;
	}
	.mobile_kefu_list .kefu_row {
		display: flex;
		align-items: center;
		margin-bottom: 8px;
		font-size: 14px;
	}
	.mobile_kefu_list .kefu_row .label {
		color: #acb6c2;
		min-width: 80px;
	}
	.mobile_kefu_list .kefu_row .value {
		color: #333;
		flex: 1;
	}
	.mobile_kefu_list .kefu_row .qrcode_img {
		width: 60px;
		height: 60px;
		object-fit: contain;
	}
	.mobile_kefu_list .kefu_actions {
		display: flex;
		justify-content: flex-end;
		gap: 10px;
	}
	.mobile_kefu_list .empty_tip {
		text-align: center;
		padding: 40px;
		color: #999;
		font-size: 14px;
	}
	.custom-switch {
		display: inline-flex;
		align-items: center;
		cursor: pointer;
	}
	.switch-track {
		width: 50px;
		height: 26px;
		background-color: #ccc;
		border-radius: 13px;
		position: relative;
		transition: background-color 0.3s;
	}
	.switch-track.switch-on {
		background-color: #67c23a;
	}
	.switch-thumb {
		width: 22px;
		height: 22px;
		background-color: #fff;
		border-radius: 50%;
		position: absolute;
		top: 2px;
		left: 2px;
		transition: transform 0.3s;
		box-shadow: 0 2px 4px rgba(0,0,0,0.2);
	}
	.switch-track.switch-on .switch-thumb {
		transform: translateX(24px);
	}
	.switch-label {
		margin-left: 12px;
		font-size: 14px;
		color: #333;
	}
</style>
